import(/* webpackMode: "eager" */ "/codebuild/output/src564434836/src/dgbet/src/app/error.tsx");
